<i18n>
{
	"en": {
		"PleaseInputToSearch": "Please input to search"
	},
	"vi": {
		"PleaseInputToSearch": "Gõ tên nhân viên, phòng ban, chức vụ để tìm kiếm."
	}
}
</i18n>

<template>
	<div>
		<!-- Block tag employee, departement, title -->
		<div class="container-watcher--block-item">
			<h6 v-if="title" class="mb-2 custom-component--title">{{ title }}<span class="text-danger" v-if="isRequired">&nbsp;*</span>:</h6>
			<v-select
				:ref="ref"
				label="name"
				v-bind="$attrs"
				v-on="$listeners"
				:filterable="false"
				:multiple="multiple"
				:options="humanRoles"
				:placeholder="placeholder"
				@search="fetchOptions"
				class="bg-white select-multiple"
				:closeOnSelect="true"
				:getOptionKey="option => ref + option.id + option.type"
			>
				<template #option="{ name, type }">
					<div>
						<cbs-relation-icon :type="type" />
						{{ name }}
					</div>
				</template>
				<template #selected-option="{ type, name}">
					<cbs-relation-icon :type="type" />
					<p>{{ name }}</p>
				</template>
				<template #no-options>
					{{ noOptionsTitle ? noOptionsTitle : $t("PleaseInputToSearch") }}
				</template>
			</v-select>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";

import * as _ from "lodash";
import HumanGql from "@/http/requests/card/human_gql.js";

export default {
	inheritAttrs: false,
	name: "CbsRelationsHumanroles",
	props: {
		type: {
			type: Number,
			default: 0
		},
		title: {
			type: String
		},
		placeholder: {
			type: String
		},
		for: {
			type: String
		},
		filter: {
			type: String
		},
		multiple: {
			type: Boolean,
			default: true
		},
		noOptionsTitle: {
			type: String
		},
		isRequired: {
			type: Boolean
		},
		modelId: Number,
		modelType: String
	},
	components: {
		"v-select": vSelect
	},
	data() {
		return {
			humanRoles: [],
			relations: null,
			ref: _.uniqueId("humanRoles_")
		};
	},
	methods: {
		fetchOptions(search, loading) {
			clearTimeout(this.timer);
			this.timer = setTimeout(async () => {
				if (!loading) {
					loading = this.$refs[this.ref] && this.$refs[this.ref].toggleLoading;
				}

				loading(true);
				try {
					await this.fetchRoles(search);
					loading(false);
				} catch (error) {
					loading(false);
				}
			}, 400);
		},
		async fetchRoles(search = "") {
			const response = await HumanGql.fetchHumanRoles({ query: search, type_id: this.type, for: this.for, object_type: this.modelType, object_id: this.modelId });
			if (response && response.humanRoles) {
				const humanRoles = response.humanRoles || [];
				if (this.filter) {
					this.humanRoles = humanRoles.filter(humanRole => humanRole.type === this.filter);
				} else {
					this.humanRoles = humanRoles;
				}
			}
		}
	}
};
</script>
<style lang="scss">
.container-watcher--block-item {
	.vs__selected {
		.inline-block {
			line-height: 100%;
		}
		.nucleo {
			color: var(--color-white);
		}
	}
}
</style>
